import React from "react";
import FaceIcon from "@mui/icons-material/Face";
import PersonIcon from "@mui/icons-material/Person";
import { thumbUrl } from "./tracksModel";

/** a track's or character's face crop; a pale placeholder when there is none or it fails to load */
export default function Face({ base, track, person, className }) {
  const src = track === -1 || track === null || track === undefined ? null : thumbUrl(base, track);
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => setFailed(false), [src]);
  return (
    <span className={"tk-face" + (className ? " " + className : "")}>
      {src && !failed ? (
        <img src={src} alt="" loading="lazy" decoding="async" draggable={false} onError={() => setFailed(true)} />
      ) : person ? (
        <PersonIcon className="tk-faceIcon" />
      ) : (
        <FaceIcon className="tk-faceIcon" />
      )}
    </span>
  );
}
